import { ApiClient } from '../client';

export function createAgentFetch(apiClient: ApiClient, customFetch?: typeof globalThis.fetch) {
  const fetchFn = customFetch || fetch;

  return async (path: string, options?: RequestInit) => {
    const fullUrl = `${apiClient.getBaseUrl()}/agent${path}`;

    // Get gymId from axios instance headers
    const axiosInstance = (apiClient as any).axiosInstance;
    const gymId = axiosInstance?.defaults?.headers?.common?.['X-Gym-Id'];

    const headers = {
      'Content-Type': 'application/json',
      ...(apiClient.getAccessToken() && { Authorization: `Bearer ${apiClient.getAccessToken()}` }),
      ...(gymId && { 'X-Gym-Id': gymId }),
      ...(options?.headers || {}),
    };

    return fetchFn(fullUrl, {
      ...options,
      headers,
    });
  };
}
